import React from 'react';

export type AvatarProps = {
  image: string;
  className?: string;
};

const Avatar = ({ image, className = '' }: AvatarProps) => (
  <div className={`pr-2.5 flex items-center ${className}`}>
    <img className='border-0 rounded-full' src={image} width={50} height={50} />
  </div>
);

export default Avatar;
